module.exports = __webpack_public_path__ + "static/media/plus28a845.2ea82f02.png";